import { render } from "./SingleBlogPage.vue?vue&type=template&id=5b92e45c"
import script from "./SingleBlogPage.vue?vue&type=script&lang=js"
export * from "./SingleBlogPage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__